/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, lockedBy: NonNullable<unknown> }} Explorer_Table_Overwrite_Locked_ErrorInputs */



/**
* | output |
* | --- |
* | "Cannot overwrite \"{name}\" as it's locked by {lockedBy}" |
*
* @param {Explorer_Table_Overwrite_Locked_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_overwrite_locked_error = /** @type {((inputs: Explorer_Table_Overwrite_Locked_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Overwrite_Locked_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible d'ecraser "${i?.name}" car il est verrouille par ${i?.lockedBy}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" kann nicht überschrieben werden, da es von ${i?.lockedBy} gesperrt ist.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile sovrascrivere "${i?.name}" perché è bloccato da ${i?.lockedBy}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Невозможно перезаписать "${i?.name}", так как он заблокирован ${i?.lockedBy}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede sobrescribir "${i?.name}" ya que está bloqueado por ${i?.lockedBy}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法覆盖“${i?.name}”，因为它已被“${i?.lockedBy}”锁定。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」は${i?.lockedBy}によってロックされているため上書きできません`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`"${i?.name}" को ओवरराइट नहीं किया जा सकता क्योंकि यह ${i?.lockedBy} द्वारा लॉक किया गया है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não é possível sobrescrever "${i?.name}" porque está bloqueado por ${i?.lockedBy}`)
	return /** @type {LocalizedString} */ (`Cannot overwrite "${i?.name}" as it's locked by ${i?.lockedBy}`)
});